import Loadable from "react-loadable";
import Loading from "components/loading";

export const DynamicImport = (loader) => Loadable({ loader, loading: Loading });
